import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { CookieHelper } from '../../common/cookie-helper';

declare let delta: any;

@Component({
  selector: 'ngc-unsupported-browser',
  templateUrl: './unsupported-browser.component.html',
  providers: [CookieHelper]
})
export class UnsupportedBrowserComponent implements AfterViewInit {
  @ViewChild('staticModal') public staticModal: ModalDirective;
  @Input() unsupportedbrowser: any;
  todayModenBrowserText = false;
  headerHide = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private cookieHelper: CookieHelper,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    if (
      this.badBrowser() &&
      (this.getBadBrowser('browserWarning') === null ||
        !(this.getBadBrowser('browserWarning').length > 0))
    ) {
      this.setBadBrowser('browserWarning', 1);
      this.showUnsupportedBrowserPopup();
    }
  }

  showUnsupportedBrowserPopup() {
    this.headerHide = true;
    this.changeDetector.detectChanges();
    this.staticModal.show();
  }

  todayModenBrowser() {
    this.todayModenBrowserText = !this.todayModenBrowserText;
  }

  unSupportedBrowserclose() {
    this.headerHide = false;
    this.staticModal.hide();
  }

  badBrowser() {
    if (isPlatformBrowser(this.platformId)) {
      const IEBrowserVersion = 11;
      const firefoxBrowserVersion = 78;
      const safariBrowserVersion = 12.1;
      const chromeBrowserVersion = 79;

      const uaVersion: any = navigator.userAgent;
      let browserVersion: any;

      if (
        uaVersion != null &&
        uaVersion.length > 0 &&
        uaVersion.indexOf('Android') > -1
      ) {
        return false;
      }

      if (
        uaVersion != null &&
        uaVersion.length > 0 &&
        uaVersion.indexOf('rv:11') > -1
      ) {
        return true;
      }

      if (uaVersion.indexOf('MSIE') > -1) {
        let compatibilityMode = false;
        if (uaVersion.indexOf('Trident/') > -1) {
          if (uaVersion.indexOf('MSIE 7.0') > -1) {
            compatibilityMode = true;
          }
        }
        browserVersion = uaVersion.substring(
          uaVersion.indexOf('MSIE') + 5,
          uaVersion.indexOf('MSIE') + 8
        );
        if (!compatibilityMode && parseInt(browserVersion) < IEBrowserVersion) {
          return true;
        }
      }

      if (uaVersion.indexOf('Firefox') > -1) {
        browserVersion = uaVersion.substring(
          uaVersion.indexOf('Firefox') + 8,
          uaVersion.indexOf('Firefox') + 12
        );
        if (parseInt(browserVersion) < firefoxBrowserVersion) {
          return true;
        }
      }

      if (uaVersion.indexOf('Safari') > -1) {
        browserVersion = uaVersion.substring(
          uaVersion.indexOf('Version') + 8,
          uaVersion.indexOf('Safari') - 1
        );
        if (
          browserVersion.substring('0', browserVersion.indexOf('.')) <
          safariBrowserVersion
        ) {
          return true;
        }
      }

      if (uaVersion.indexOf('Chrome') > -1) {
        browserVersion = uaVersion.substring(
          uaVersion.indexOf('Chrome') + 7,
          uaVersion.indexOf('Chrome') + 11
        );
        if (parseInt(browserVersion) < chromeBrowserVersion) {
          return true;
        }
      }

      if (
        uaVersion != null &&
        uaVersion.length > 0 &&
        (uaVersion.indexOf('OPERA') > -1 ||
          uaVersion.indexOf('Opera') > -1 ||
          uaVersion.indexOf('OPR') > -1)
      ) {
        return true;
      }
      return false;
    }
  }

  setBadBrowser(cookieName, expiredays) {
    this.cookieHelper.setCookies(cookieName, expiredays);
  }

  getBadBrowser(cookieName) {
    const browserCookie = this.cookieHelper.getCookies(cookieName);
    if (browserCookie != null && browserCookie.length > 0) {
      return browserCookie;
    }
    return '';
  }
}
